// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars

const defaultTheme = {
  fontSize: '36px',
  fontWeight: '500',
};

const PageHeader = ({
  headerText, ...otherProps
}) => (
  <Heading level={1} headingStyle="heading6" theme={defaultTheme} className="dls-deep-blue" {...otherProps}>
    {headerText}
  </Heading>
);

export default PageHeader;

PageHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
};
